import gql from "graphql-tag";

export const contentPostDetailsFragment = gql`
    fragment ContentPostDetailsFragment on BlogPostField {
        id
        title
        status
        body
        coverImages(raw: true)
        youtubeVideo
        videoContent {
            id
            status
            type
            url {
                url
            }
        }
        numberOfViews
        readingTime
        created
        modified
        topic {
            id
            name
        }
        ogShareUrl
        shareUrl
        flaggedByUser
        author {
            id
            firstName
            lastName
            profilePhoto
            university {
                id
                name
            }
            degree {
                id
                name
            }
            active
            archived
            accountRole
            country {
                id
                code
                name
            }
            mentorFields {
                primaryFlag {
                    code
                    name
                }
                secondaryFlag {
                    code
                    name
                }
            }
        }
    }
`;
